const cacheKey = (orgId: string, product: string, domain: string) =>
  `eco-suite-navbar:app-switcher-visibility:${orgId}:${product}:${domain}`

/**
 * Reads a previously cached app-switcher visibility result from sessionStorage.
 * Returns `undefined` on a cache miss or if sessionStorage is unavailable.
 * The cache is scoped to the combination of org/tenant id, product, and flag domain
 * so different users, products, or environments never share entries.
 */
export function read(orgId: string, product: string, domain: string): boolean | undefined {
  try {
    const raw = sessionStorage.getItem(cacheKey(orgId, product, domain))
    if (raw === 'true') return true
    if (raw === 'false') return false
    return undefined
  } catch {
    // sessionStorage unavailable (e.g. cross-origin iframe, storage blocked)
    return undefined
  }
}

/**
 * Writes an app-switcher visibility result to sessionStorage.
 * Fails silently if sessionStorage is unavailable or quota is exceeded —
 * the next mount will simply re-fetch.
 */
export function write(orgId: string, product: string, domain: string, value: boolean): void {
  try {
    sessionStorage.setItem(cacheKey(orgId, product, domain), String(value))
  } catch {
    // Quota exceeded or storage blocked — fail silently
  }
}
